{
  "en": {
    "resultSkillPrompt": "Help me turn the approach behind “{title}” into a reusable company Skill.",
    "draftResultLineage": "Revision {version} of this draft produced the result.",
    "skillResultLineage": "Version {version} of this Skill produced the result.",
    "publishedSkillResultLineage": "{name} is published now, so a chat that uses it follows the published version.",
    "agentThey": "They",
    "agentEditorRemoved": "{name} can no longer edit it.",
    "agentEditGranted": "Granted. {name} can edit it.",
    "agentEditDeclined": "Declined. {name} are told.",
    "agentEditAccessRequested": "Asked for edit access. You will hear back in your Inbox.",
    "agentCreatedOn": "{name} is on.",
    "agentCreatedReady": "{name} is ready. Run it whenever you need it.",
    "agentArchived": "{name} is archived.",
    "agentRestoredVersion": "Restored version {version} as the newest version."
  },
  "bg": {
    "resultSkillPrompt": "Помогнете ми да превърна подхода зад „{title}“ в многократно използваемо умение на компанията.",
    "draftResultLineage": "Ревизия {version} на тази чернова създаде резултата.",
    "skillResultLineage": "Версия {version} на това умение създаде резултата.",
    "publishedSkillResultLineage": "{name} вече е публикувано, така че чатът, който го използва, следва публикуваната версия.",
    "agentThey": "Те",
    "agentEditorRemoved": "{name} вече не може да го редактира.",
    "agentEditGranted": "Разрешено. {name} може да го редактира.",
    "agentEditDeclined": "Отказано. {name} е уведомен.",
    "agentEditAccessRequested": "Поискан е достъп за редактиране. Ще получите отговор във входящата си поща.",
    "agentCreatedOn": "{name} е включен.",
    "agentCreatedReady": "{name} е готов. Стартирайте го, когато ви е необходимо.",
    "agentArchived": "{name} е архивиран.",
    "agentRestoredVersion": "Версия {version} е възстановена като най-новата версия."
  },
  "hr": {
    "resultSkillPrompt": "Pomozite mi pretvoriti pristup iz odjeljka „{title}” u višekratno upotrebljivu vještinu tvrtke.",
    "draftResultLineage": "Revizija {version} ovog nacrta proizvela je rezultat.",
    "skillResultLineage": "Verzija {version} ove vještine proizvela je rezultat.",
    "publishedSkillResultLineage": "{name} je sada objavljen/a, pa razgovor koji ga/je koristi slijedi objavljenu verziju.",
    "agentThey": "Oni",
    "agentEditorRemoved": "{name} više ga/je ne može uređivati.",
    "agentEditGranted": "Odobreno. {name} ga/je može uređivati.",
    "agentEditDeclined": "Odbijeno. {name} je obaviješten/a.",
    "agentEditAccessRequested": "Zatražen je pristup za uređivanje. Odgovor ćete dobiti u ulaznoj pošti.",
    "agentCreatedOn": "{name} je aktivan/na.",
    "agentCreatedReady": "{name} je spreman/na. Pokrenite ga/je kad god vam zatreba.",
    "agentArchived": "{name} je arhiviran/a.",
    "agentRestoredVersion": "Verzija {version} vraćena je kao najnovija verzija."
  },
  "cs": {
    "resultSkillPrompt": "Pomozte mi převést přístup z „{title}“ na znovu použitelnou firemní dovednost.",
    "draftResultLineage": "Revize {version} tohoto konceptu vytvořila výsledek.",
    "skillResultLineage": "Verze {version} této dovednosti vytvořila výsledek.",
    "publishedSkillResultLineage": "{name} je nyní publikovaná, takže chat, který ji používá, se řídí publikovanou verzí.",
    "agentThey": "Oni",
    "agentEditorRemoved": "{name} už ji nemůže upravovat.",
    "agentEditGranted": "Uděleno. {name} ji může upravovat.",
    "agentEditDeclined": "Zamítnuto. {name} byl/a informován/a.",
    "agentEditAccessRequested": "Požádali jste o přístup k úpravám. Odpověď najdete ve své doručené poště.",
    "agentCreatedOn": "{name} je zapnutý.",
    "agentCreatedReady": "{name} je připravený. Spusťte ho, kdykoli ho potřebujete.",
    "agentArchived": "{name} je archivovaný.",
    "agentRestoredVersion": "Verze {version} byla obnovena jako nejnovější verze."
  },
  "da": {
    "resultSkillPrompt": "Hjælp mig med at gøre tilgangen bag “{title}” til en genanvendelig virksomhedskompetence.",
    "draftResultLineage": "Revision {version} af dette udkast førte til resultatet.",
    "skillResultLineage": "Version {version} af denne kompetence førte til resultatet.",
    "publishedSkillResultLineage": "{name} er udgivet nu, så en chat, der bruger den, følger den udgivne version.",
    "agentThey": "De",
    "agentEditorRemoved": "{name} kan ikke længere redigere den.",
    "agentEditGranted": "Godkendt. {name} kan redigere den.",
    "agentEditDeclined": "Afvist. {name} får besked.",
    "agentEditAccessRequested": "Der er bedt om redigeringsadgang. Du får svar i din indbakke.",
    "agentCreatedOn": "{name} er aktiv.",
    "agentCreatedReady": "{name} er klar. Kør den, når du har brug for det.",
    "agentArchived": "{name} er arkiveret.",
    "agentRestoredVersion": "Version {version} er gendannet som den nyeste version."
  },
  "nl": {
    "resultSkillPrompt": "Help me om de aanpak achter “{title}” om te zetten in een herbruikbare bedrijfsvaardigheid.",
    "draftResultLineage": "Revisie {version} van dit concept leverde het resultaat op.",
    "skillResultLineage": "Versie {version} van deze vaardigheid leverde het resultaat op.",
    "publishedSkillResultLineage": "{name} is nu gepubliceerd, dus een chat die deze gebruikt, volgt de gepubliceerde versie.",
    "agentThey": "Zij",
    "agentEditorRemoved": "{name} kan het niet meer bewerken.",
    "agentEditGranted": "Toegekend. {name} kan het bewerken.",
    "agentEditDeclined": "Afgewezen. {name} is geïnformeerd.",
    "agentEditAccessRequested": "Bewerkingstoegang aangevraagd. Je krijgt bericht in je Postvak IN.",
    "agentCreatedOn": "{name} is actief.",
    "agentCreatedReady": "{name} is klaar. Start het wanneer je het nodig hebt.",
    "agentArchived": "{name} is gearchiveerd.",
    "agentRestoredVersion": "Versie {version} is hersteld als nieuwste versie."
  },
  "et": {
    "resultSkillPrompt": "Aita mul muuta „{title}“ taga olev lähenemine korduvkasutatavaks ettevõtte oskuseks.",
    "draftResultLineage": "Selle mustandi redaktsioon {version} andis tulemuse.",
    "skillResultLineage": "Selle oskuse versioon {version} andis tulemuse.",
    "publishedSkillResultLineage": "{name} on nüüd avaldatud, seega järgib seda kasutav vestlus avaldatud versiooni.",
    "agentThey": "Nad",
    "agentEditorRemoved": "{name} ei saa seda enam muuta.",
    "agentEditGranted": "Lubatud. {name} saab seda muuta.",
    "agentEditDeclined": "Keeldutud. {name} on sellest teavitatud.",
    "agentEditAccessRequested": "Muutmisõigust taotletud. Saad vastuse oma postkasti.",
    "agentCreatedOn": "{name} on sisse lülitatud.",
    "agentCreatedReady": "{name} on valmis. Käivita see, kui vaja.",
    "agentArchived": "{name} on arhiveeritud.",
    "agentRestoredVersion": "Versioon {version} taastati uusima versioonina."
  },
  "fi": {
    "resultSkillPrompt": "Auta minua tekemään lähestymistavasta “{title}” uudelleenkäytettävä yrityksen taito.",
    "draftResultLineage": "Tämän luonnoksen versio {version} tuotti tuloksen.",
    "skillResultLineage": "Tämän taidon versio {version} tuotti tuloksen.",
    "publishedSkillResultLineage": "{name} on nyt julkaistu, joten sitä käyttävä keskustelu noudattaa julkaistua versiota.",
    "agentThey": "He",
    "agentEditorRemoved": "{name} ei voi enää muokata sitä.",
    "agentEditGranted": "Myönnetty. {name} voi muokata sitä.",
    "agentEditDeclined": "Hylätty. {name} saa tiedon.",
    "agentEditAccessRequested": "Muokkausoikeutta pyydettiin. Saat vastauksen Saapuneet-kansioosi.",
    "agentCreatedOn": "{name} on käytössä.",
    "agentCreatedReady": "{name} on valmis. Käynnistä se, kun tarvitset sitä.",
    "agentArchived": "{name} on arkistoitu.",
    "agentRestoredVersion": "Versio {version} palautettiin uusimmaksi versioksi."
  },
  "fr": {
    "resultSkillPrompt": "Aidez-moi à transformer l’approche derrière « {title} » en une compétence d’entreprise réutilisable.",
    "draftResultLineage": "La révision {version} de ce brouillon a produit le résultat.",
    "skillResultLineage": "La version {version} de cette compétence a produit le résultat.",
    "publishedSkillResultLineage": "{name} est maintenant publiée : une conversation qui l’utilise suit la version publiée.",
    "agentThey": "Iel",
    "agentEditorRemoved": "{name} ne peut plus la modifier.",
    "agentEditGranted": "Accordé. {name} peut la modifier.",
    "agentEditDeclined": "Refusé. {name} en est informé.",
    "agentEditAccessRequested": "Demande d’accès en modification envoyée. Vous recevrez une réponse dans votre boîte de réception.",
    "agentCreatedOn": "{name} est activé.",
    "agentCreatedReady": "{name} est prêt. Exécutez-le quand vous en avez besoin.",
    "agentArchived": "{name} est archivé.",
    "agentRestoredVersion": "La version {version} a été restaurée comme version la plus récente."
  },
  "de": {
    "resultSkillPrompt": "Hilf mir, den Ansatz hinter „{title}“ in einen wiederverwendbaren Unternehmens-Skill umzuwandeln.",
    "draftResultLineage": "Überarbeitung {version} dieses Entwurfs hat das Ergebnis erzeugt.",
    "skillResultLineage": "Version {version} dieses Skills hat das Ergebnis erzeugt.",
    "publishedSkillResultLineage": "{name} ist jetzt veröffentlicht. Ein Chat, der ihn verwendet, nutzt die veröffentlichte Version.",
    "agentThey": "Die Person",
    "agentEditorRemoved": "{name} kann es nicht mehr bearbeiten.",
    "agentEditGranted": "Gewährt. {name} kann es bearbeiten.",
    "agentEditDeclined": "Abgelehnt. {name} wird benachrichtigt.",
    "agentEditAccessRequested": "Bearbeitungszugriff angefordert. Sie erhalten in Ihrem Posteingang eine Rückmeldung.",
    "agentCreatedOn": "{name} ist aktiviert.",
    "agentCreatedReady": "{name} ist bereit. Führen Sie ihn aus, wann immer Sie ihn benötigen.",
    "agentArchived": "{name} ist archiviert.",
    "agentRestoredVersion": "Version {version} als neueste Version wiederhergestellt."
  },
  "el": {
    "resultSkillPrompt": "Βοήθησέ με να μετατρέψω την προσέγγιση πίσω από το «{title}» σε επαναχρησιμοποιήσιμη εταιρική Δεξιότητα.",
    "draftResultLineage": "Η αναθεώρηση {version} αυτού του προσχεδίου παρήγαγε το αποτέλεσμα.",
    "skillResultLineage": "Η έκδοση {version} αυτής της Δεξιότητας παρήγαγε το αποτέλεσμα.",
    "publishedSkillResultLineage": "Το {name} δημοσιεύτηκε, επομένως μια συνομιλία που το χρησιμοποιεί ακολουθεί τη δημοσιευμένη έκδοση.",
    "agentThey": "Αυτοί",
    "agentEditorRemoved": "Το {name} δεν μπορεί πλέον να το επεξεργαστεί.",
    "agentEditGranted": "Παραχωρήθηκε. Το {name} μπορεί να το επεξεργαστεί.",
    "agentEditDeclined": "Απορρίφθηκε. Το {name} ενημερώθηκε.",
    "agentEditAccessRequested": "Ζητήθηκε πρόσβαση επεξεργασίας. Θα ενημερωθείς στα Εισερχόμενά σου.",
    "agentCreatedOn": "Το {name} ενεργοποιήθηκε.",
    "agentCreatedReady": "Το {name} είναι έτοιμο. Εκτέλεσέ το όποτε το χρειάζεσαι.",
    "agentArchived": "Το {name} αρχειοθετήθηκε.",
    "agentRestoredVersion": "Η έκδοση {version} επαναφέρθηκε ως η νεότερη έκδοση."
  },
  "hu": {
    "resultSkillPrompt": "Segíts a „{title}” mögött rejlő megközelítést újrafelhasználható vállalati készséggé alakítani.",
    "draftResultLineage": "A piszkozat {version}. verziója hozta létre ezt az eredményt.",
    "skillResultLineage": "A készség {version}. verziója hozta létre ezt az eredményt.",
    "publishedSkillResultLineage": "A(z) {name} mostantól közzé van téve, ezért az azt használó csevegés a közzétett verziót követi.",
    "agentThey": "Ők",
    "agentEditorRemoved": "A(z) {name} többé nem szerkesztheti.",
    "agentEditGranted": "Engedélyezve. A(z) {name} szerkesztheti.",
    "agentEditDeclined": "Elutasítva. A(z) {name} értesítést kap.",
    "agentEditAccessRequested": "Szerkesztési hozzáférést kértél. A Beérkező üzenetek között kapsz választ.",
    "agentCreatedOn": "A(z) {name} aktív.",
    "agentCreatedReady": "A(z) {name} készen áll. Futtasd, amikor szükséged van rá.",
    "agentArchived": "A(z) {name} archiválva.",
    "agentRestoredVersion": "A(z) {version}. verziót visszaállítottuk legújabb verzióként."
  },
  "ga": {
    "resultSkillPrompt": "Cabhraigh liom an cur chuige atá taobh thiar de “{title}” a iompú ina Scil ath-inúsáidte don chuideachta.",
    "draftResultLineage": "Tháirg athbhreithniú {version} den dréacht seo an toradh.",
    "skillResultLineage": "Tháirg leagan {version} den Scil seo an toradh.",
    "publishedSkillResultLineage": "Tá {name} foilsithe anois, mar sin leanann comhrá a úsáideann é an leagan foilsithe.",
    "agentThey": "Siad",
    "agentEditorRemoved": "Ní féidir le {name} é a chur in eagar a thuilleadh.",
    "agentEditGranted": "Deonaíodh é. Is féidir le {name} é a chur in eagar.",
    "agentEditDeclined": "Diúltaíodh dó. Cuireadh é sin in iúl do {name}.",
    "agentEditAccessRequested": "Iarradh rochtain eagarthóireachta. Gheobhaidh tú freagra i do Bhosca Isteach.",
    "agentCreatedOn": "Tá {name} ann.",
    "agentCreatedReady": "Tá {name} réidh. Rith é aon uair a theastaíonn sé uait.",
    "agentArchived": "Tá {name} curtha i gcartlann.",
    "agentRestoredVersion": "Athchóiríodh leagan {version} mar an leagan is nuaí."
  },
  "it": {
    "resultSkillPrompt": "Aiutami a trasformare l'approccio alla base di “{title}” in una competenza aziendale riutilizzabile.",
    "draftResultLineage": "La revisione {version} di questa bozza ha prodotto il risultato.",
    "skillResultLineage": "La versione {version} di questa competenza ha prodotto il risultato.",
    "publishedSkillResultLineage": "{name} è ora pubblicata, quindi una chat che la usa segue la versione pubblicata.",
    "agentThey": "Loro",
    "agentEditorRemoved": "{name} non può più modificarla.",
    "agentEditGranted": "Concesso. {name} può modificarla.",
    "agentEditDeclined": "Rifiutata. {name} è stato informato.",
    "agentEditAccessRequested": "Richiesto l'accesso alla modifica. Riceverai una risposta nella Posta in arrivo.",
    "agentCreatedOn": "{name} è attivo.",
    "agentCreatedReady": "{name} è pronto. Eseguilo ogni volta che ti serve.",
    "agentArchived": "{name} è archiviato.",
    "agentRestoredVersion": "La versione {version} è stata ripristinata come versione più recente."
  },
  "lv": {
    "resultSkillPrompt": "Palīdzi man pārvērst pieeju, kas izmantota aiz “{title}”, atkārtoti lietojamā uzņēmuma prasmē.",
    "draftResultLineage": "Rezultātu radīja šī melnraksta {version}. versija.",
    "skillResultLineage": "Rezultātu radīja šīs prasmes {version}. versija.",
    "publishedSkillResultLineage": "{name} tagad ir publicēta, tāpēc tērzēšanā, kurā tā tiek izmantota, tiek lietota publicētā versija.",
    "agentThey": "Viņi",
    "agentEditorRemoved": "{name} vairs nevar to rediģēt.",
    "agentEditGranted": "Piešķirta. {name} var to rediģēt.",
    "agentEditDeclined": "Noraidīta. {name} par to ir informēts.",
    "agentEditAccessRequested": "Pieprasīta rediģēšanas piekļuve. Atbildi saņemsi iesūtnē.",
    "agentCreatedOn": "{name} ir aktīvs.",
    "agentCreatedReady": "{name} ir gatavs. Palaid to, kad vien nepieciešams.",
    "agentArchived": "{name} ir arhivēts.",
    "agentRestoredVersion": "Versija {version} atjaunota kā jaunākā versija."
  },
  "lt": {
    "resultSkillPrompt": "Padėkite man paversti požiūrį, slypintį už „{title}“, pakartotinai naudojamu įmonės įgūdžiu.",
    "draftResultLineage": "Šio juodraščio {version} versija sugeneravo rezultatą.",
    "skillResultLineage": "Šio įgūdžio {version} versija sugeneravo rezultatą.",
    "publishedSkillResultLineage": "{name} dabar paskelbtas, todėl jį naudojantis pokalbis vadovaujasi paskelbta versija.",
    "agentThey": "Jie",
    "agentEditorRemoved": "{name} nebegali jo redaguoti.",
    "agentEditGranted": "Suteikta. {name} gali jį redaguoti.",
    "agentEditDeclined": "Atmesta. {name} apie tai pranešta.",
    "agentEditAccessRequested": "Paprašyta redagavimo prieigos. Atsakymą gausite gautuosiuose.",
    "agentCreatedOn": "{name} dabar aktyvus.",
    "agentCreatedReady": "{name} paruoštas. Paleiskite jį, kai tik prireiks.",
    "agentArchived": "{name} suarchyvuotas.",
    "agentRestoredVersion": "{version} versija atkurta kaip naujausia versija."
  },
  "mt": {
    "resultSkillPrompt": "Għinni nbiddel l-approċċ wara “{title}” f’Ħila tal-kumpanija li tista’ terġa’ tintuża.",
    "draftResultLineage": "Ir-reviżjoni {version} ta’ dan l-abbozz tat ir-riżultat.",
    "skillResultLineage": "Il-verżjoni {version} ta’ din il-Ħila tat ir-riżultat.",
    "publishedSkillResultLineage": "{name} issa hija ppubblikata, għalhekk chat li jużaha jsegwi l-verżjoni ppubblikata.",
    "agentThey": "Huma",
    "agentEditorRemoved": "L-aċċess ta’ {name} għall-editjar tneħħa.",
    "agentEditGranted": "Aċċess mogħti. {name} issa għandu aċċess għall-editjar tagħha.",
    "agentEditDeclined": "Miċħud. Intbagħtet notifika lil {name}.",
    "agentEditAccessRequested": "Intalab aċċess għall-editjar. Se tirċievi tweġiba fl-Inbox tiegħek.",
    "agentCreatedOn": "L-aġent {name} huwa attiv.",
    "agentCreatedReady": "L-aġent {name} huwa lest. Ħaddmu kull meta jkollok bżonnu.",
    "agentArchived": "L-aġent {name} ġie arkivjat.",
    "agentRestoredVersion": "Il-verżjoni {version} ġiet restawrata bħala l-aktar verżjoni ġdida."
  },
  "pl": {
    "resultSkillPrompt": "Pomóż mi przekształcić podejście stojące za „{title}” w wielokrotnego użytku umiejętność firmową.",
    "draftResultLineage": "Wersja {version} tego szkicu wygenerowała wynik.",
    "skillResultLineage": "Wersja {version} tej umiejętności wygenerowała wynik.",
    "publishedSkillResultLineage": "{name} jest już opublikowana, więc czat, który z niej korzysta, używa opublikowanej wersji.",
    "agentThey": "Oni",
    "agentEditorRemoved": "{name} nie może już jej edytować.",
    "agentEditGranted": "Przyznano dostęp. {name} może ją edytować.",
    "agentEditDeclined": "Odrzucono. {name} otrzyma powiadomienie.",
    "agentEditAccessRequested": "Poproszono o dostęp do edycji. Odpowiedź otrzymasz w skrzynce odbiorczej.",
    "agentCreatedOn": "{name} jest włączony.",
    "agentCreatedReady": "{name} jest gotowy. Uruchom go, kiedy tylko potrzebujesz.",
    "agentArchived": "{name} został zarchiwizowany.",
    "agentRestoredVersion": "Przywrócono wersję {version} jako najnowszą wersję."
  },
  "pt": {
    "resultSkillPrompt": "Ajude-me a transformar a abordagem por trás de “{title}” em uma habilidade reutilizável da empresa.",
    "draftResultLineage": "A revisão {version} deste rascunho produziu o resultado.",
    "skillResultLineage": "A versão {version} desta habilidade produziu o resultado.",
    "publishedSkillResultLineage": "{name} foi publicada, então um chat que a utiliza seguirá a versão publicada.",
    "agentThey": "Eles",
    "agentEditorRemoved": "{name} não pode mais editá-la.",
    "agentEditGranted": "Concedido. {name} pode editá-la.",
    "agentEditDeclined": "Recusado. {name} foi informado.",
    "agentEditAccessRequested": "Acesso para edição solicitado. Você receberá uma resposta na sua Caixa de entrada.",
    "agentCreatedOn": "{name} está ativo.",
    "agentCreatedReady": "{name} está pronto. Execute-o sempre que precisar.",
    "agentArchived": "{name} foi arquivado.",
    "agentRestoredVersion": "A versão {version} foi restaurada como a versão mais recente."
  },
  "ro": {
    "resultSkillPrompt": "Ajută-mă să transform abordarea din spatele „{title}” într-o abilitate reutilizabilă a companiei.",
    "draftResultLineage": "Revizia {version} a acestei schițe a produs rezultatul.",
    "skillResultLineage": "Versiunea {version} a acestei abilități a produs rezultatul.",
    "publishedSkillResultLineage": "{name} este publicată acum, așa că un chat care o folosește urmează versiunea publicată.",
    "agentThey": "Ei",
    "agentEditorRemoved": "{name} nu mai poate edita acest element.",
    "agentEditGranted": "Aprobat. {name} poate edita acest element.",
    "agentEditDeclined": "Refuzat. {name} a fost informat(ă).",
    "agentEditAccessRequested": "Accesul pentru editare a fost solicitat. Vei primi un răspuns în Inbox.",
    "agentCreatedOn": "{name} este activ.",
    "agentCreatedReady": "{name} este gata. Rulează-l ori de câte ori ai nevoie.",
    "agentArchived": "{name} este arhivat.",
    "agentRestoredVersion": "Versiunea {version} a fost restaurată ca cea mai nouă versiune."
  },
  "sk": {
    "resultSkillPrompt": "Pomôžte mi premeniť prístup za „{title}“ na opakovane použiteľnú firemnú zručnosť.",
    "draftResultLineage": "Výsledok vytvorila revízia {version} tohto konceptu.",
    "skillResultLineage": "Výsledok vytvorila verzia {version} tejto zručnosti.",
    "publishedSkillResultLineage": "{name} je teraz publikovaná, takže chat, ktorý ju používa, pracuje s publikovanou verziou.",
    "agentThey": "Oni",
    "agentEditorRemoved": "{name} už nemôže upravovať túto položku.",
    "agentEditGranted": "Schválené. {name} môže túto položku upravovať.",
    "agentEditDeclined": "Zamietnuté. {name} boli informovaní.",
    "agentEditAccessRequested": "Požiadali ste o prístup na úpravy. Odpoveď dostanete v doručenej pošte.",
    "agentCreatedOn": "{name} je zapnutý.",
    "agentCreatedReady": "{name} je pripravený. Spustite ho, kedykoľvek ho potrebujete.",
    "agentArchived": "{name} je archivovaný.",
    "agentRestoredVersion": "Verzia {version} bola obnovená ako najnovšia verzia."
  },
  "sl": {
    "resultSkillPrompt": "Pomagajte mi pristop za »{title}« pretvoriti v ponovno uporabljivo veščino podjetja.",
    "draftResultLineage": "Revizija {version} tega osnutka je ustvarila rezultat.",
    "skillResultLineage": "Različica {version} te veščine je ustvarila rezultat.",
    "publishedSkillResultLineage": "{name} je zdaj objavljena, zato klepet, ki jo uporablja, uporablja objavljeno različico.",
    "agentThey": "Oni",
    "agentEditorRemoved": "{name} tega ne more več urejati.",
    "agentEditGranted": "Odobreno. {name} lahko ureja.",
    "agentEditDeclined": "Zavrnjeno. {name} je obveščen.",
    "agentEditAccessRequested": "Zaprosili ste za dostop za urejanje. Odgovor boste prejeli v nabiralniku.",
    "agentCreatedOn": "{name} je vklopljen.",
    "agentCreatedReady": "{name} je pripravljen. Zaženite ga, ko ga potrebujete.",
    "agentArchived": "{name} je arhiviran.",
    "agentRestoredVersion": "Različica {version} je bila obnovljena kot najnovejša različica."
  },
  "es": {
    "resultSkillPrompt": "Ayúdame a convertir el enfoque detrás de «{title}» en una Habilidad reutilizable de la empresa.",
    "draftResultLineage": "La revisión {version} de este borrador produjo el resultado.",
    "skillResultLineage": "La versión {version} de esta Habilidad produjo el resultado.",
    "publishedSkillResultLineage": "{name} ya está publicada, por lo que un chat que la use seguirá la versión publicada.",
    "agentThey": "Ellos",
    "agentEditorRemoved": "{name} ya no puede editarla.",
    "agentEditGranted": "Concedido. {name} puede editarla.",
    "agentEditDeclined": "Rechazado. Se ha informado a {name}.",
    "agentEditAccessRequested": "Se solicitó acceso de edición. Recibirás una respuesta en tu Bandeja de entrada.",
    "agentCreatedOn": "{name} está activo.",
    "agentCreatedReady": "{name} está listo. Ejecútalo cuando lo necesites.",
    "agentArchived": "{name} está archivado.",
    "agentRestoredVersion": "Se restauró la versión {version} como la versión más reciente."
  },
  "sv": {
    "resultSkillPrompt": "Hjälp mig att omvandla metoden bakom ”{title}” till en återanvändbar företagsfärdighet.",
    "draftResultLineage": "Revision {version} av det här utkastet genererade resultatet.",
    "skillResultLineage": "Version {version} av den här färdigheten genererade resultatet.",
    "publishedSkillResultLineage": "{name} är publicerad nu, så en chatt som använder den följer den publicerade versionen.",
    "agentThey": "De",
    "agentEditorRemoved": "{name} kan inte längre redigera den.",
    "agentEditGranted": "Beviljat. {name} kan redigera den.",
    "agentEditDeclined": "Nekat. {name} har informerats.",
    "agentEditAccessRequested": "Begäran om redigeringsåtkomst skickad. Du får svar i din inkorg.",
    "agentCreatedOn": "{name} är aktiverad.",
    "agentCreatedReady": "{name} är redo. Kör den när du behöver den.",
    "agentArchived": "{name} är arkiverad.",
    "agentRestoredVersion": "Version {version} återställdes som den senaste versionen."
  }
}
